module.exports = __webpack_public_path__ + "img/会泽县者海医院.42afcae5.png";